import { render, staticRenderFns } from "./MalattieInfettiveStrutturaViewPage.vue?vue&type=template&id=5505e91a"
import script from "./MalattieInfettiveStrutturaViewPage.vue?vue&type=script&lang=js"
export * from "./MalattieInfettiveStrutturaViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports